module.exports = __webpack_public_path__ + "img/underReview.05714b4e.png";